(function($) {
$(function(){

  /*****
    Set some global variables
  *****/
  var template_url = $('#template_url').val();


  /*****
    iOS Viewport check
  *****/
  var isVHCheckNeeded = vhCheck();
  var hasVHCKeckValue = document.documentElement.style.getPropertyValue('--vh-offset');
  if (isVHCheckNeeded && hasVHCKeckValue) {
    $('body').addClass('use-ios-offset');
  }


  /*****
    Nav toggle
  *****/
  $('.site-menu-toggle').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('html').attr('data-nav-state', $('html').attr('data-nav-state') == 'closed' ? 'open' : 'closed');
  });


  /*****
    Responsive videos in posts
  *****/
  if ($('.allow-responsive-video').length) {
    $('.allow-responsive-video').fitVids();
  }


  /*****
    Fancybox
    ---
    This is just sample code, to be extended
  *****/
  $().fancybox({
    selector : '.video-lightbox, .photo-lightbox',
    hash: false,
    buttons: ['close'],
    infobar: false,
    idleTime: 300,
    loop: true,
    btnTpl: {
    close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' + return_svg('close') + '</button>',
    arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<div>'+ return_svg('scroll_arrow') +'</div>' +
      "</button>",
    arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<div>'+ return_svg('scroll_arrow') +'</div>' +
      "</button>",
    },
    beforeShow: function(){
      $('.fancybox-content .lightbox-custom-caption').remove();
    },
    afterShow: function(instance, slide){
      var fancytitle = instance.current.opts.fancytitle || false;
      var fancysubtitle = instance.current.opts.fancysubtitle || false;
      var fancycaption = instance.current.opts.fancycaption || false;
      var fancydownloadtitle = instance.current.opts.fancydownloadtitle || false;
      var fancydownloadurl = instance.current.opts.fancydownloadurl || false;

      if (fancytitle || fancysubtitle || fancycaption || fancydownloadtitle || fancydownloadurl) {
        $('.fancybox-content').append('<div class="lightbox-custom-caption"></div>');

        if (fancytitle) {
          $('.lightbox-custom-caption').append('<h3 class="lightbox-title">'+ fancytitle +'</h3>');
        }

        if (fancysubtitle) {
          $('.lightbox-custom-caption').append('<p class="lightbox-subtitle">'+ fancysubtitle +'</p>');
        }

        if (fancycaption) {
          $('.lightbox-custom-caption').append('<div class="lightbox-caption nice-type">'+ fancycaption +'</div>');
        }

        if (fancydownloadtitle || fancydownloadurl) {
          $('.lightbox-custom-caption').append('<p class="lightbox-download"><a class="button" target="_blank" href="'+ fancydownloadurl +'">'+ fancydownloadtitle +'</a></p>');
        }
      }
    }
  });


  /*****
    Flickity
  *****/
  if ($('.home-video-items').length) {
    $('.home-video-items').flickity({
      cellSelector: '.home-videos-items-slide',
      cellAlign: 'center',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 5000,
      wrapAround: true,
      imagesLoaded: true
    });

    // Go to the previous item
    $('.home-video-items .prev').on('click', function(e){
      e.preventDefault();
      var parent = $('.home-video-items');
      parent.flickity('previous');
    });

    // Go to the next item
    $('.home-video-items .next').on('click', function(e){
      e.preventDefault();
      var parent = $('.home-video-items');
      parent.flickity('next');
    });
  }


  /*****
    Home social load-in
    ---
    Done via JS to improve loading times
  *****/
  if ($('#load_in_social').length) {
    setTimeout(function(){
      $("#load_in_social").load(template_url + "/partials/social.php", function() {
        $('#load_in_social_outer').show();
      });
    }, 500);
  }


});
})(jQuery);
